var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apply"},[_c('img',{attrs:{"src":_vm.data.url,"alt":""}}),_c('div',{staticClass:"apple__right"},[_c('p',[_vm._v(_vm._s(_vm.data.title))]),_c('p',[_vm._v(_vm._s(_vm.data.des))])]),_c('div',{staticClass:"line"}),_c('div',{staticClass:"apple__bt cursor",on:{"click":_vm.changeShow}},[_c('p',[_vm._v("申请接入")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }